<script>
  import Select from 'svelte-select';
  import { onMount } from 'svelte';
  import { client } from 'root/api/index.js';
  import InfiniteScroll from 'components/DataTable/InfiniteScroll.svelte';
  import Loader from '../Loader.svelte';
  import { Modal } from 'bootstrap';
  import { getContext, onDestroy } from 'svelte';
  const showDialog = getContext('showDialog');
  let pageSize = 30;
  let pageNumber = 1;
  let totalPages = 0;
  let filterGroups = [];
  let isPaginationLoading = false;
  let searchFilterGroupTimeout;
  const getTaskFilterGroupList = (searchKeyword) => {
    searchFilterGroupTimeout && clearTimeout(searchFilterGroupTimeout);
    searchFilterGroupTimeout = setTimeout(() => {
      isPaginationLoading = true;
      client
        .taskFilterGroupList(pageSize, pageNumber, {
          searchKeyword: searchKeyword == undefined ? '' : searchKeyword,
          userId,
          clientId,
        })
        .then((response) => {
          isPaginationLoading = false;
          if (response.data.pagination.pageNumber == 1) {
            filterGroups = response.data.payload;
          } else {
            filterGroups = [...filterGroups, ...response.data.payload];
          }
          totalPages = response.data.pagination.totalPage;
        });
    }, 500);
  };

  let taskGroupModal;
  let userId = '';
  let clientId = '';
  export const show = (filterUserId, flag) => {
    userId = flag == 'user' && filterUserId ? filterUserId : '';
    clientId = flag == 'client' && filterUserId ? filterUserId : '';
    taskGroupModal = new Modal(document.getElementById('taskGroupModal'), {
      keyboard: false,
    });
    filterGroups = [];
    pageNumber = 1;
    taskGroupModal.show();
    getTaskFilterGroupList();
  };

  export let showGroup = () => {};
</script>

<!-- Modal -->
<div
  class="modal fade"
  id="taskGroupModal"
  tabindex="-1"
  aria-labelledby="taskGroupModal"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title font-size-14"
          id=""
        >
          Groups
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body modal-body-height">
        <div class="search-client-input position-relative">
          <img
            class="position-absolute"
            alt=""
            src="/images/search.svg"
          />
          <input
            class="form-control"
            on:keyup={(e) => {
              getTaskFilterGroupList(e.target.value);
            }}
            placeholder="Search by group name"
            type="text"
          />
        </div>
        {#if filterGroups.length == 0}
          <div class="my-4">
            <span class="color-lead text-center font-size-16 mt-2 d-block"
              >You have not created any groups yet. Select assignee and click save group to create a
              new group.</span
            >
          </div>
        {/if}
        {#each filterGroups as group}
          <div class="d-flex flex-row align-items-center group-list-items py-2">
            <div class="w-100 d-flex flex-column me-2">
              <span class="font-weight-400 font-size-14 text-break color-blue groups-name"
                >{group.name}</span
              >
              <span class="total-members-count d-block mt-1">{group.userCount} Members</span>
            </div>
            {#if !(userId > 0 || clientId > 0)}
              <button
                on:click={() => {
                  client
                    .taskFilterGroupGet({ id: group.id })
                    .then((response) => {
                      taskGroupModal.hide();
                      showGroup('select', response.data);
                    })
                    .catch((err) => {
                      showDialog({
                        type: 'warning',
                        message: [err],
                      });
                    });
                }}
                class="btn-select shadow-none border-0"
              >
                Select
              </button>
            {/if}
            {#if userId > 0 || clientId > 0 || group.readonly == 0}
              <button
                on:click={() => {
                  client
                    .taskFilterGroupGet({ id: group.id })
                    .then((response) => {
                      taskGroupModal.hide();
                      showGroup('edit', response.data);
                    })
                    .catch((err) => {
                      showDialog({
                        type: 'warning',
                        message: [err],
                      });
                    });
                }}
                class="btn-select shadow-none border-0 ms-1"
              >
                Edit
              </button>

              <button
                on:click={() => {
                  client.taskFilterGroupDelete({ id: group.id }).then((response) => {
                    filterGroups = [];
                    pageNumber = 1;
                    getTaskFilterGroupList();
                  });
                }}
                class="btn-trash shadow-none border-0 ms-1"
              >
                Delete
              </button>
            {/if}
          </div>
        {/each}

        <InfiniteScroll
          threshold={300}
          hasMore={pageNumber < totalPages}
          isLoading={isPaginationLoading}
          on:loadMore={() => {
            pageNumber = pageNumber + 1;
            getTaskFilterGroupList();
          }}
        >
          <div
            class="scroll-spinner-container d-flex justify-content-center
			align-items-center"
          >
            <Loader />
          </div>
        </InfiniteScroll>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="trans-btn my-0 px-4 font-size-12 outline-0 btn-cancel font-size-12"
          data-bs-dismiss="modal">Cancel</button
        >
        {#if userId > 0 || clientId > 0}
          <button
            type="button"
            class="my-0 px-4 font-size-12 outline-0 btn-primary font-size-12"
            on:click={() => showGroup('add')}
            data-bs-dismiss="modal">Create Group</button
          >
        {/if}
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .group-list-items {
    border-bottom: 1px solid rgba($input-border-color, 0.4);
    .btn-trash {
      transition-duration: 0.2s;
      background: $red-color !important;
      color: $white-color;
      width: 70px;
      height: 25px;
      border-radius: 4px;
      line-height: 13px;
      border-radius: 0px;
      &:hover {
        background: rgba($input-border-color, 0.4);
      }
    }
    .btn-select {
      transition-duration: 0.2s;
      background: rgba($blue-color, 0.1);
      color: $blue-color;
      width: 70px;
      height: 25px;
      border-radius: 4px;
      line-height: 13px;
      border-radius: 0px;
      &:hover {
        background: rgba($input-border-color, 0.4);
      }
      &:focus {
        background: $input-border-color;
      }
    }
    &:last-child {
      border-bottom: 0px;
    }
  }
  .total-members-count {
    font-size: 11px;
  }
  .groups-name {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 335px;
  }
</style>
